import * as Components from './components';
import * as Graphs from './graphs';
import Tabs from './tabs';
import ListContainer from './list';

import Routes from './sensors.router';
import options from './sensors.component';

const Component = {
    selector: 'dtSensorsAndConnectors',
    options
};

export {
    Component,
    Components,
    Routes,
    Tabs,
    ListContainer,
    Graphs
};



// WEBPACK FOOTER //
// ./app/components/sensors-and-connectors/index.js